import type { SVGProps } from 'react';
import * as React from 'react';

const MinusCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/minus-circle">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21.5999C17.302 21.5999 21.6 17.3018 21.6 11.9999C21.6 6.69797 17.302 2.3999 12 2.3999C6.69809 2.3999 2.40002 6.69797 2.40002 11.9999C2.40002 17.3018 6.69809 21.5999 12 21.5999ZM8.10003 11.0999C7.60297 11.0999 7.20003 11.5028 7.20003 11.9999C7.20003 12.497 7.60297 12.8999 8.10003 12.8999H15.9C16.3971 12.8999 16.8 12.497 16.8 11.9999C16.8 11.5028 16.3971 11.0999 15.9 11.0999H8.10003Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export default MinusCircleIcon;
